
import { Tarea, TareaPaginaFiltro } from "@/model/Tarea";
import { TareaService } from "@/services/TareaService";
import { Constantes } from "@/Util/Constantes";
import { HeaderTemplate, Utilidades } from "@/Util/Utilidades";
import Vue from "vue";

export default Vue.extend({
  props: {
    dialog: Boolean,    
  },
  data() {
    return {
      headers: new Array<Object>() as Array<HeaderTemplate>,
      busqueda: "" as string,
      loading: false as boolean,
      tareas: new Array<Object>() as Array<Tarea>       
    };
  },
  mounted() {
    this.montarHeaders();
  },
  methods: {
    async cargarTareasPagina() {
      this.loading = true;
      this.tareas = new Array<Object>() as Array<Tarea>;

      let filtro = new Object() as TareaPaginaFiltro;
      filtro.pagina = this.$store.state.page;
      filtro.filtrar_tareas_perfil = 0;

      await TareaService.getTareasPaginaAsync(filtro)
        .then((x) => (this.tareas = x.data))
        .catch((x) =>
          Utilidades.Message({ message: Constantes.ERROR_CARGAR_DATOS, error: true })
        );

      this.loading = false;
    },
    montarHeaders() {
      this.headers = new Array<Object>() as Array<HeaderTemplate>;
      this.headers.push(
        Utilidades.nuevoHeader({ text: "Tarea", value: "cod_tarea" })
      );

      this.headers.push(
        Utilidades.nuevoHeader({ text: "Descripcion", value: "descripcion" })
      );

      this.headers.push(
        Utilidades.nuevoHeader({ text: "", value: "txt_tiene_tarea" })
      );
    },
  },
});
